import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useCycle } from "framer-motion";
import Link from "next/link";
import cx from "classnames";
import { GiHamburgerMenu } from "react-icons/gi";
import { format } from "date-fns";
import useWindowPosition from "@/utils/useWindowPosition";
import { navLinks } from "@/data/navLinks";
import Image from "next/image";
import { NavLink } from "@/data/navLinks";

const itemVariants = {
  closed: {
    opacity: 0,
  },
  open: { opacity: 1 },
};
const sideVariants = {
  closed: {
    transition: {
      staggerChildren: 0.1,
      staggerDirection: -1,
    },
  },
  open: {
    transition: {
      staggerChildren: 0.2,
      staggerDirection: 1,
    },
  },
};
const MobileNav = () => {
  const [open, cycleOpen] = useCycle(false, true);
  const [showNav, setShowNav] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const position = useWindowPosition();

  const node = useRef(null) as unknown as React.MutableRefObject<HTMLInputElement>;

  const handleClick = (e: MouseEvent) => {
    if (node?.current?.contains(e.target as Node)) {
      return;
    }
    // outside click
    if (open) {
      cycleOpen();
    }
  };

  useEffect(() => {
    if (position < scrollPosition) {
      setShowNav(true);
    } else {
      setShowNav(false);
    }
    setScrollPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position]);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    // document.addEventListener('scroll', handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      // document.removeEventListener('scroll', handleClick);
    };
  });
  return (
    <>
      <nav className="fixed z-40">
        <AnimatePresence>
          {open && (
            <motion.aside
              initial={{ width: 0 }}
              animate={{
                width: 300,
              }}
              exit={{
                width: 0,
                transition: { delay: 0.2, duration: 0.3 },
              }}
              ref={node}
            >
              <motion.div
                className="h-screen p-10 text-gray-900 bg-white shadow-2xl dark:bg-dark-background dark:text-white flex flex-col justify-between"
                initial="closed"
                animate="open"
                exit="closed"
                variants={sideVariants}
              >
                <div className="p-2">
                  <Link href={NavLink.HOME} className="flex justify-center">
                    <Image
                      key={"/images/logo.png"}
                      src={"/images/logo.png"}
                      width={85}
                      height={66}
                      alt="pcollins.tech"
                    />
                  </Link>
                </div>
                <div className="mt-10">
                  <nav>
                    <ul className="pb-6">
                      {navLinks.map((link) => (
                        <motion.li
                          whileHover={{ scale: 1.1 }}
                          variants={itemVariants}
                          className={cx({
                            "p-2 cursor-pointer hover:text-pink-500 text-lg text-center":
                              true,
                          })}
                          key={link.label}
                        >
                          <Link
                            href={link.route}
                            className="text-base leading-7 uppercase"
                          >
                            {link.label}
                          </Link>
                        </motion.li>
                      ))}
                    </ul>
                  </nav>
                </div>
                <p className=" text-center text-gray-700 bottom-10">
                  {format(new Date(), "yyyy")} &copy; Pcollins.tech
                  <br />
                  All rights reserved.
                </p>
              </motion.div>
            </motion.aside>
          )}
        </AnimatePresence>

        <motion.button
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => cycleOpen()}
          type="button"
          aria-label="Menu Button"
          className={cx({
            "fixed p-4 rounded-full shadow-lg text-xl bottom-6 right-6 bg-pink-500 text-white":
              true,
          })}
        >
          <GiHamburgerMenu />
        </motion.button>
      </nav>
      <div
        className={cx({
          "top-0 z-100 md:px-4 transition ease-in-out flex items-center justify-between w-full p-2 ":
            true,
          "sticky ": !open && (showNav || position < 10),
          "bg-dark-background text-gray-900 dark:text-white  shadow-2xl ":
            scrollY >= 75,
        })}
      >
        <Link href={NavLink.HOME}>
          <Image
            key={"/images/logoWhite.png"}
            src={"/images/logoWhite.png"}
            width="85"
            height="66"
            alt="pcollins.tech"
          />
        </Link>
      </div>
    </>
  );
};
export default MobileNav;
